import { render } from "./AccidentsView.vue?vue&type=template&id=fd74b39e&scoped=true"
import script from "./AccidentsView.vue?vue&type=script&lang=js"
export * from "./AccidentsView.vue?vue&type=script&lang=js"

import "./AccidentsView.vue?vue&type=style&index=0&id=fd74b39e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd74b39e"]])

export default __exports__